import MetricInfoModal from "../../../ComponentParts/CVE/MetricInfoModal.mjs";
import Glob from "../../../libs/Glob.mjs";
import './SimulationFlowSettings2Modal.css'
import {Button, ButtonGroup, Form, InputGroup, InputGroupText, Label} from "reactstrap";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import CheckIcon from "../../../media/images/CheckIcon.mjs";
import AppCheckboxOnIcon from "../../../media/app-images/AppCheckboxOnIcon.mjs";
import AppCheckboxOffIcon from "../../../media/app-images/AppCheckboxOffIcon.mjs";
import MySelect from "../../../controls/MySelect.mjs";

const prefix = "SimulationFlowSettings2Modal";


const SimulationFlowSettings2Modal = class extends MetricInfoModal {
	constructor(props) {
		super(props);
		this.state.scope = props.selected ?? 'subject';
		this.state.scopeList = [
			{value: 'resource', label: Glob.label('Resource')+': '+props.option.risorsaLabel},
			{value: 'subject', label: Glob.label('Main subject')+': '+props.option.subjectLabel},
			{value: 'perimeter', label: Glob.label('Perimeter')},
		];
		this.state.selected = !!props.selected;
		this.save = this.save.bind(this);
	}

	save() {
		if (typeof this.props.save === 'function') {
			this.props.save( this.state.selected ? this.state.scope : false );
		}
	}
	saveButton() {
		return(
			<ButtonGroup
				className={"btn-icon"}
			>
				<Button
					color={"success"}
					onClick={ this.save }
					disabled={ !this.state.changed }
				>
					<b><TextLabel value={"Save"} /></b>
					<i><CheckIcon /></i>
				</Button>
			</ButtonGroup>
		)
	}
	customRender() {
		return (
			<div className={`${prefix}-content`}>
				<Form>
					<InputGroup>
						<InputGroupText>
							<Label>
								<TextLabel value={"Score"} />:
							</Label>
						</InputGroupText>
						<InputGroupText>
							{ this.props.option?.details?.finalScore }
						</InputGroupText>
						<InputGroupText
							className={"flex-grow-1 d-flex"}
							style={{cursor: "pointer"}}
							onClick={ e => {
								e.stopPropagation();
								this.setState({selected: !this.state.selected, changed: true} );
							}}
						>
							<span style={{minWidth:"25%"}} />
							{ this.state.selected ? <AppCheckboxOnIcon /> : <AppCheckboxOffIcon /> }
							<span className={"flex-grow-1"}>
								{ this.state.selected ?
									<strong><TextLabel value={'Active'} /></strong> :
									<em><TextLabel value={'Inactive'} /></em>
								}
							</span>
						</InputGroupText>
					</InputGroup>
					<InputGroup style={{flexWrap:"nowrap"}}>
						<InputGroupText>
							<Label>
								<TextLabel value={"Scope"}/>:
							</Label>
						</InputGroupText>
						<div className={"flex-grow-1"}>
							<MySelect
								isDisabled={ ! this.state.selected }
								placeholder={Glob.label("Select")}
								value={this.state.scopeList.find(o => o?.value === this.state.scope) || null}
								onChange={ opt => this.setState({scope: opt?.value, changed: true})}
								options={ this.state.scopeList }
							/>
						</div>
					</InputGroup>
				</Form>
			</div>
		)
	}
}

export default SimulationFlowSettings2Modal;
